<div [ngClass]="variant">
  @if (!loading) {
    <img
      src="https://flagcdn.com/w2560/{{ language.countryAlpha2Code | lowercase }}.png"
      [alt]="'common.alt-image' | transloco"
      />
  } @else {
    <c-spinner [loading]="true" color="secondary"></c-spinner>
  }
  <div>{{ language.languageAlpha2Code | uppercase }}</div>
</div>

